module.exports = __webpack_public_path__ + "static/media/8-3.570ac61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/8-3.png
// module id = 1689
// module chunks = 0 1